import React, { useEffect, useState } from "react";

import Board from "./Board";

import { Get } from "utils/request";
import { CircularProgress } from "@mui/material";
import { Pagination } from "@mui/material";  
import { useDispatch } from "react-redux";
import { Show } from "actions/SnackbarActions";
import { useParams } from "react-router";

const Table = props => {

    const {
        search = ""
    } = props;

    const [groups, SetGroups] = useState([]);
    const [loading, SetLoading] = useState(false);

    const [page, SetPage] = useState(1);
    const [maxPage, SetMaxPage] = useState(1);

    const { id } = useParams();
    const dispatch = useDispatch();

    const GetData = async () => {
        SetLoading(true);
        let response = await Get(`courses-main/groups?courseId=${id}&search=${search}&page=${page}`);
        SetLoading(false);
         
        if (response?.status === true) {
            SetGroups(response?.groups);
            SetMaxPage(response?.pagination.lastPage);
        } else if (!response) dispatch(Show({
            show: true,
            message: "Falha ao carregar as turmas",
            severity: "warning"
        }));
    }

    useEffect(GetData, [search, page]);

    return (
        <div>
            <div className="table-responsive">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            <th>Nome</th>
                            <th>Início</th>
                            <th>Encerramento</th>
                            <th>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {!loading && groups?.map((value, index) => (
                            <Board
                                key={index}
                                groupId={value?.id}
                                name={value?.name}
                                sub_start={value?.sub_start}
                                sub_end={value?.sub_end}

                                description={value?.description}
                                OnDelete={GetData}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="w100 flex jcc">
                <CircularProgress hidden={!loading}/>
                <p hidden={groups?.length !== 0 || loading}>Nenhuma turma encontrada</p>
            </div>
            <Pagination
                className={(maxPage == 1 ? "hide" : "")}
                style={{display: "flex", justifyContent: "flex-end"}} 
                count={maxPage} 
                value={page}
                onChange={(_, value) => SetPage(value)}
            />
        </div>
    );
}

export default Table;